"use client";

import { useEffect, useRef } from "react";
import {
  Box,
  Card,
  CardBody,
  Text,
  useColorMode,
  Link,
  Heading,
} from "@chakra-ui/react";
import GiveawayBanner from "../components/GiveawayBanner/GiveawayBanner";
import { getCurrentColor } from "../constants";
import { Helmet } from "react-helmet";

function GleamWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://widget.gleamjs.io/e.js";
    script.async = true;

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <Box ref={containerRef} w="full" maxW="4xl" mx="auto" overflow="visible">
      <a
        className="e-widget no-button"
        href="https://gleam.io/fuYv1/free-ammo-for-life-giveaway"
        rel="nofollow"
      >
        Free Ammo For Life Giveaway!
      </a>
    </Box>
  );
}

const priceDetailsData = [
  {
    title: "Lifetime Supply",
    description: "Win enough 9mm ammunition to last you decades to come!",
  },
  {
    title: "Increase Your Chances",
    description:
      "After entry, complete tasks to gain additional entries and increase your chance to win!",
  },
  {
    title: "Premium Quality",
    description: "Top-tier ammunition from leading manufacturers.",
  },
  {
    title: "No Purchase Necessary",
    description:
      "Enter with just your email. Open to all eligible participants 21+.",
  },
];

export default function Giveaway() {
  const { colorMode } = useColorMode();

  const renderPriceDetails = (priceDetailsData, index) => {
    return (
      <Card
        justifySelf={"center"}
        variant="outline"
        minH={"220px"}
        w={{ base: "100%", md: "250px" }}
        key={index}
      >
        <CardBody
          textAlign="center"
          bg={getCurrentColor(colorMode, "blueC.1200", "")}
        >
          <Text
            fontSize="24px"
            fontWeight="bold"
            color={getCurrentColor(colorMode, "gray.700", "whiteC.100")}
            mb={2}
            fontFamily={'"Geist", sans-serif'}
            maxW={"180px"}
            mx={"auto"}
          >
            {priceDetailsData.title}
          </Text>
          <Text
            fontSize="18px"
            color={getCurrentColor(colorMode, "gray.700", "whiteC.100")}
            fontFamily={'"Geist", sans-serif'}
          >
            {priceDetailsData.description}
          </Text>
        </CardBody>
      </Card>
    );
  };

  return (
    <Box>
      <Helmet>
        <title>Free Ammo For Life Giveaway | BulletScout</title>
        <meta
          name="description"
          content="Enter to win a lifetime supply of ammunition. One lucky winner will receive one free case of ammunition per year for the next 80 years."
        />

      </Helmet>

      <GiveawayBanner />

      <Box py={{ base: 8, md: 12 }} px={4}>
        <Box maxW="6xl" mx="auto">
          <Text
            fontSize={{ base: "3xl", md: "4xl" }}
            fontWeight="bold"
            textAlign="center"
            color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
            mb={{ base: 6, md: 8 }}
            fontFamily={'"Geist", sans-serif'}
          >
            Prize Details
          </Text>
          <Box
            display="grid"
            gridTemplateColumns={{
              base: "1fr",
              sm: "1fr 1fr",
              lg: "repeat(4, 1fr)",
            }}
            gap={6}
          >
            {priceDetailsData.map((priceDetail, index) =>
              renderPriceDetails(priceDetail, index)
            )}
          </Box>
        </Box>
      </Box>

      <Box
        py={{ base: 8, md: 12 }}
        px={4}
        bg={getCurrentColor(colorMode, "#F2F6FA", "transparent")}
      >
        <Box maxW="4xl" mx="auto">
          <Card
            boxShadow="md"
            border="none"
            bg={getCurrentColor(colorMode, "", "blueC.1000")}
          >
            <CardBody p={{ base: 5, md: 8 }}>
              {/* <Box mb={8}>
                <Heading as="h2" size="lg" mb={4} textAlign="center">
                  Prize Details
                </Heading>
                <Text fontSize="md" color="gray.600" textAlign="center">
                  One lucky winner will receive one free case of ammunition per
                  year for the next 80 years. That's 80,000 rounds of ammunition
                  over a lifetime!
                </Text>
              </Box> */}

              <Heading as="h3" size="md" mb={6} textAlign="center">
                Enter Your Email to Win
              </Heading>

              <GleamWidget />

              <Box
                fontSize="sm"
                color="gray.500"
                textAlign="center"
                mt={{ base: 3, md: 4 }}
                maxW="md"
                mx="auto"
                fontFamily={'"Geist", sans-serif'}
              >
                By entering, you agree to our{" "}
                <Link
                  href="/giveaway-terms-and-conditions"
                  textDecoration="underline"
                  color="blue.600"
                  _hover={{ color: "blue.800" }}
                  fontFamily={'"Geist", sans-serif'}
                >
                  Terms & Conditions
                </Link>
                .<Text>Must be 21+ to enter. No purchase necessary.</Text>
              </Box>
            </CardBody>
          </Card>
        </Box>
      </Box>
    </Box>
  );
}
